<template>
    <div>
        <v-dialog v-model="display" persistent width="500">
            <v-card>
                <v-card-title>
                    {{ title }}
                </v-card-title>
                <v-card-subtitle>{{ $t('EXT_WORKSHOP_SUBTITLE') }}</v-card-subtitle>
                <v-card-text>
                    <div class="text-center" v-if="loading.data">
                        <v-progress-circular
                            indeterminate
                            color="primary">
                        </v-progress-circular>
                    </div>
                    <v-form
                        ref="form"
                        v-model="valid"
                        v-if="!loading.data">
                        <v-text-field 
                            :label="$t('EXT_WORKSHOP_NAME')"
                            v-model="form.name"
                            :rules="rules.name"
                            :disabled="uneditableField('name')"
                            >
                        </v-text-field>
                        <v-text-field
                            :label="$t('EXT_WORKSHOP_PHONE')"
                            v-model="form.phone"
                            :rules="rules.phone"
                            :disabled="uneditableField('phone')">
                        </v-text-field>
                        <v-text-field
                            :label="$t('EXT_WORKSHOP_ADDRESS')"
                            v-model="form.address"
                            :disabled="uneditableField('address')">
                        </v-text-field>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        @click="submit()" 
                        :disabled="!valid || loading.submit"
                        :loading="loading.submit"
                        text>
                            {{ $t('BTN_SAVE') }}
                        </v-btn>
                    <v-btn @click="close()" text>
                        {{ $t('BTN_CANCEL') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <AlertDialog
            ref="alertDialog"/>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import AlertDialog from "../components/AlertDialog";
import inArray from '../utils/inArray';
export default {
    name: "ExternalWorkshopDialog",
    components: {
        AlertDialog
    },
    data() {
        return {
            display: false,
            valid: false,
            editMode: false,
            id: null,
            form: {
                name: null,
                phone: null,
                address: null
            },
            rules: {
                name: [
                    v => !!v || this.$t('RULES_REQUIRED_MSG')
                ],
                phone: [
                    v => !isNaN(v) || this.$t('RULES_NUMERIC_MSG')
                ]
            },
            loading: {
                data: false,
                submit: false
            }
        }
    },
    computed: {
        ...mapState("externalWorkshop", ["externalWorkshop"]),
        title() {
            if(!this.editMode) return this.$t('EXT_WORKSHOP_NEW_TITLE');
            else return this.$t('EXT_WORKSHOP_EDIT_TITLE');
        }
    },
    methods: {
        ...mapActions("externalWorkshop", ["fetchExternalWorkshop", "fetchExternalWorkshops", "storeExternalWorkshop", "updateExternalWorkshop"]),
        async open(params) {
            this.loading.data = true;
            this.editMode = params.editMode;
            this.display = true;
            if(this.editMode) {
                this.id = params.id;
                await this.fetchExternalWorkshop(this.id);
                this.form = this.externalWorkshop;
            }
            this.loading.data = false;
        },
        close() {
            this.display = false;
            this.loading.submit = false;
            this.$refs.form.reset();
            this.$refs.form.resetValidation();  
        },
        submit() {
            this.loading.submit = true;
            if(!this.editMode) {
                this.storeExternalWorkshop(this.form)
                    .then(response => {
                        this.close();
                        this.$refs.alertDialog.open(this.$t('SUCCESS_TITLE'), response.message);
                        this.$emit("record", response.record);
                        this.$emit("submit");
                    })
                    .catch(error => {
                        this.close();
                        this.$refs.alertDialog.open(this.$t('ERROR_TITLE'), error.message);
                    })
            } else {
                this.updateExternalWorkshop({id: this.id, form: this.form})
                    .then(response => {
                        this.close();
                        this.$refs.alertDialog.open(this.$t('SUCCESS_TITLE'), response.message);
                        this.$emit("submit");
                    })
                    .catch(error => {
                        this.close();
                        this.$refs.alertDialog.open(this.$t('ERROR_TITLE'), error.message);
                    })
            }

        },
        inArray,
        uneditableField(field) {
            return this.form.meta && inArray(field, this.form.meta.uneditable_fields) && this.editMode;
        }
    }
}
</script>